module.exports = __webpack_public_path__ + "img/al.c2b05705.svg";